import { render, staticRenderFns } from "./Matches.vue?vue&type=template&id=35ccbf42&scoped=true&"
import script from "./Matches.vue?vue&type=script&lang=js&"
export * from "./Matches.vue?vue&type=script&lang=js&"
import style0 from "./Matches.vue?vue&type=style&index=0&id=35ccbf42&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35ccbf42",
  null
  
)

component.options.__file = "Matches.vue"
export default component.exports